module.exports = __webpack_public_path__ + "img/bogorpools.9b03382c.png";